import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table, Text } from "@pentabd/ui";

import { SelectControllerVertical } from "@components";
import { TableColumn } from "./TableColumn";

import { useManpowerSummaryReports } from "@hooks/HRM/reports/useManpowerSummaryReports";
import { useBaseData } from "@hooks/useBaseData";
import { useLanguage } from "@hooks/useLanguage";
import { useQueries } from "@hooks/useQueries";

import { getConvertedUnitData } from "@helpers/baseDataConvert";

import { BASE_DATA } from "@constants/base-data";

const { WINGS } = BASE_DATA;

export const ManpowerSummaryTable = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { register, setValue, control } = useForm();

  const { data: wings } = useBaseData(WINGS);

  const { getManpowerSummaryData, handleParams } = useManpowerSummaryReports();
  const { handleQuery, setSearchParams } = useQueries();

  useEffect(() => {
    setSearchParams(undefined);
  }, []);

  return (
    <div className="pt-10">
      <div className="bg-light rounded p-10 mb-10">
        <div className="row pb-0 mb-0">
          <SelectControllerVertical
            label="REPORTS.MANPOWER_REPORTS.FILTERS.WINGS"
            name="unitId"
            register={{ ...register("unitId") }}
            options={getConvertedUnitData(wings, language) || []}
            setValue={setValue}
            selectAction={(e) => {
              handleParams(e as number);
              handleQuery("unitId", e?.toString() as string);
            }}
            control={control}
            cols={6}
            portal
            isSearchable
          />
        </div>
      </div>
      {getManpowerSummaryData?.data && (
        <Text
          weight="semibold"
          color="title"
          size="lg"
          className="text-center d-block text-underline py-10"
        >
          {getManpowerSummaryData?.positionNameBn}
        </Text>
      )}
      <Table
        columns={TableColumn(t) || []}
        rows={getManpowerSummaryData?.data || []}
      />
    </div>
  );
};
